import GetMisionData from '../components/GetMisionData'

export default function MisionData() {
    return (
        <div>
            <GetMisionData />
        </div>
    );
}
